import $ from 'jquery';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import debounce from 'just-debounce';
import VanillaModal from 'vanilla-modal';
import AutoplayTimer from '../components/AutoplayTimer';
import yt from '../globals/youtube';

export default class HomeSlideshow {
  constructor(section) {
    this.$body = $(document.body);
    this.$window = $(window);
    this.$section = section;
    this.$el = $(section.el);
    this.data = section.data;

    this.$slideshow = this.$el.find('[data-slideshow]');
    this.$slides = this.$el.find('[data-slideshow-slide]');
    this.autoplay = this.data.should_autoplay && this.data.autoplay
      ? this.data.autoplay * 1000
      : false;

    this.windowWidth = $(window).width();
    this.gridSpacing = parseInt(window.Theme.gridSpacing, 10) || 0;
    this.hasSidebar = window.Theme.hasSidebar;
    this.fadeOpacity = false;
    this.$slideNavigation = this.$el.find('.dot');
    this.continueAutoplay = true;
    this.currentTimer;

    this.$videoSlides = this.$el.find('.slideshow-slide-video-background');

    this.modalId = `slideshow-video-${this.$section.id}-modal`;
    this.$modal = this.$el.find(`.${this.modalId}-content`);
    this.$modalToggleOpen = this.$el.find('[data-slideshow-video-modal-open]');
    this.$modalToggleClose = this.$el.find('[data-slideshow-video-modal-close]');


    if (this.data.slide_count > 1) {
      this._initFlickity();
    }

    if (this.$videoSlides.length) {
      if (this.$el.find('.overlay-opacity-100').length === 0 && this.$el.find('[data-slideshow-slide]:nth-of-type(1) .slideshow-slide-video-background').length > 0) {
        this.fadeOpacity = true;
        this.$el.find('.slideshow-slide-info-container').addClass('overlay-opacity-100');
      }
    }

    this._initVideoSlides();

    this._bindEvents();

    if (this.data.slide_count > 1 && this.autoplay) {
      this.$el.find('.is-selected').addClass('is-timing');

      this.currentTimer = new AutoplayTimer(() => {
        this.flickity.next(true);
        this.$el.find('.is-selected').addClass('is-timing');
      }, this.autoplay);

      this.flickity.on('cellSelect', () => {
        if (this.continueAutoplay) {
          this.currentTimer.stop();
          this.$el.find('.is-selected').addClass('is-timing');

          this.currentTimer = new AutoplayTimer(() => {
            this.flickity.next(true);
            this.$el.find('.is-selected').addClass('is-timing');
          }, this.autoplay);
        }
      });

      this.flickity.on('dragStart', () => {
        this.continueAutoplay = false;
        this.currentTimer.stop();
        this.$slideNavigation.removeClass('is-timing');
        this._resetAutoPlay();
      });
    }
  }

  _resetAutoPlay() {
    setTimeout(() => {
      this.continueAutoplay = true;
      this.$el.find('.is-selected').addClass('is-timing');
      this.currentTimer.stop();

      this.currentTimer = new AutoplayTimer(() => {
        this.flickity.next(true);
        this.$el.find('.is-selected').addClass('is-timing');
      }, this.autoplay);
    }, 10000);
  }

  _initFlickity() {
    this.flickity = new Flickity(this.$slideshow[0], {
      accessibility: true,
      adaptiveHeight: true,
      autoPlay: false,
      cellSelector: '[data-slideshow-slide]',
      imagesLoaded: true,
      pageDots: true,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      wrapAround: true,
      selectedAttraction: 0.01,
      friction: 0.15,
    });

    this.$slides.on('focusin.slideshow', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const slideIndex = this.$slides.index($(event.currentTarget));
      this.flickity.select(slideIndex, false, true);
      this.flickity.reloadCells();
    });
  }

  _initVideoSlides() {
    this.$videoSlides.each((index, el) => {
      const parentSlide = $(el).parents('.slideshow-slide');
      const slideId = $(el).attr('id');
      const videoId = $(el).attr('data-video-id');
      if (!videoId) return;

      // Remove YouTube API iframes from the slides if mobile device
      if (/Mobi/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent)) {
        if (this.fadeOpacity) {
          setTimeout(() => {
            this.$el.find('.slideshow-slide-info-container').removeClass('overlay-opacity-100');
          }, 700);
        }

        return;
      }

      yt(() => {
        const player = new YT.Player(slideId, {
          videoId: videoId,
          events: {
            onReady: (mute) => {
              player.mute();

              if (parentSlide.hasClass('is-selected')) {
                player.playVideo();
              } else {
                player.pauseVideo();
              }

              this.flickity.on('cellSelect', () => {
                if (parentSlide.hasClass('is-selected')) {
                  player.playVideo();
                } else {
                  player.pauseVideo();
                }
              });

              this.$modalToggleOpen.on('click', (event) => {
                player.pauseVideo();
              });

              this.$modalToggleClose.on('click', (event) => {
                player.playVideo();
              });

              if (this.fadeOpacity) {
                setTimeout(() => {
                  this.$el.find('.slideshow-slide-info-container').removeClass('overlay-opacity-100');
                }, 700);
              }
            },
          },
          playerVars: {
            enablejsapi: 1,
            autoplay: 1,
            controls: 0,
            showinfo: 0,
            modestbranding: 1,
            playlist: videoId,
            loop: 1,
            autohide: 0,
            rel: 0,
          }
        });
      });
    });
  }

  _bindEvents() {
    $(window).on('blur', () => {
      this.currentTimer.pause();
    });

    $(window).on('focus', () => {
      this.currentTimer.resume();
    });

    this.$modalToggleOpen.on('click', event => {
      event.preventDefault();

      const $btn = $(event.currentTarget);
      const id = $btn.attr('href');
      this._openModal(id);
    });

    this.$modalToggleClose.on('click', event => {
      event.preventDefault();
      this._closeModal();
    });
  }

  _centerModal($modal) {
    const modalHeight = $modal.outerHeight();
    const headerHeight = !this.hasSidebar && $(this.$section.el).is(':first-child') ? 80 : 0;
    const marginTop = (window.innerHeight - modalHeight - headerHeight - (this.gridSpacing * 2)) / 2;

    $modal.css({marginTop});

    $('html, body').animate({
      scrollTop: this.$el.offset().top
    }, 1000);
  }

  _openModal(id) {
    const $modal = this.$el.find(`.${this.modalId}-content`);

    this.modal = new VanillaModal({
      loadClass: 'modal-loaded',
      class: '',
      modal: `.${this.modalId}`,
      modalInner: `.${this.modalId}-inner`,
      modalContent: `.${this.modalId}-content`,
      onOpen: () => {
        this.$body
          .addClass('overlay-visible')
          .addClass(`${this.modalId}-visible`);

        this._centerModal($modal);

        this.$window.on('resize.slideshow-modal', debounce(() => {
          if (this.windowWidth !== $(window).width()) {
            this._centerModal($modal);
          }
        }, 200));

        this.continueAutoplay = false;
        this.currentTimer.stop();

        this.$el.find('.slideshow-slide-video-icon').toggleClass('hide');

        // Autoplay
        const iframe = this.$modal.find('iframe')[0];
        if (iframe) {
          iframe.src += '&autoplay=1';

          if (iframe.src.match(/youtube/)) {
            const player = new YT.Player(iframe.id, {
              events: { onReady: event => player.playVideo() },
            });
          }
        }
      },
    });

    this.modal.open(id);
  }

  _closeModal() {
    this._resetAutoPlay();

    this.$body
      .removeClass('overlay-visible')
      .removeClass(`${this.modalId}-visible`);

    this.$el.find('.slideshow-slide-video-icon').toggleClass('hide');

    this.$window.off('.slideshow-modal');

    const iframe = this.$modal.find('iframe')[0];
    if (iframe) {
      iframe.src = iframe.src.replace('&autoplay=1', '');
    }

    if (this.modal) {
      this.modal.close();
      this.modal.destroy();
      this.modal = null;
    }
  }

  _unbindEvents() {
    this.$slides.off('focusin.slideshow');
  }

  onSectionBlockSelect(block) {
    const $slides = $('[data-slideshow-slide]');
    const slideIndex = $slides.index($(block.el));

    if (!$(block.el).hasClass('is-selected')) {
      this.flickity.select(slideIndex, false, false);
    }

    if (this.autoplay) {
      this.continueAutoplay = false;
      this.$slideNavigation.removeClass('is-timing');
      this.currentTimer.stop();
    }
  }

  onSectionBlockDeselect() {
    if (this.autoplay) {
      this._resetAutoPlay();
    }
  }

  onSectionUnload() {
    this.flickity.destroy();
    this._unbindEvents();
    this.modal.destroy();
  }
}
